import { httpClient } from 'utils/httpClient';
import {
  TrasladoPayload, AprobarTrasladoPayload, TrasladoResponse,
} from 'types/traslado.types';

export const trasladoService = {
  async listarPorAnio(anioEscolarId: number): Promise<TrasladoResponse[]> {
    try {
      return await httpClient.get<TrasladoResponse[]>(`/traslados?anioEscolarId=${anioEscolarId}`);
    } catch { return []; }
  },
  async getByEstudiante(estudianteId: number): Promise<TrasladoResponse[]> {
    try {
      return await httpClient.get<TrasladoResponse[]>(`/traslados/estudiante/${estudianteId}`);
    } catch { return []; }
  },
  async crear(payload: TrasladoPayload, solicitanteId: number): Promise<TrasladoResponse> {
    return httpClient.post<TrasladoResponse>(`/traslados?solicitanteId=${solicitanteId}`, payload);
  },
  async aprobar(id: number, payload: AprobarTrasladoPayload): Promise<TrasladoResponse> {
    return httpClient.put<TrasladoResponse>(`/traslados/${id}/aprobar`, payload);
  },
  async ejecutar(id: number): Promise<TrasladoResponse> {
    return httpClient.put<TrasladoResponse>(`/traslados/${id}/ejecutar`, {});
  },
  async rechazar(id: number, observacion?: string): Promise<TrasladoResponse> {
    return httpClient.put<TrasladoResponse>(`/traslados/${id}/rechazar`, observacion ? { observacion } : {});
  },
  async exonerarDeuda(id: number): Promise<TrasladoResponse> {
    return httpClient.put<TrasladoResponse>(`/traslados/${id}/exonerar-deuda`, {});
  },
};
